<div class="px-5 pt-5 pb-2 text-secondary">
  <span><strong>USS Role:</strong> {{ getRoleDisplayLabel(getSelectedProjectRole()) }}</span>
</div>
@if (!isSelectedProjectAPersonalProject) {
  <div class="p-5">
    @if (!isReaderSelectedProject()) {
      <button
        type="button"
        (click)="editProject()"
        class="btn btn-primary me-2"
        [disabled]="!canEditSelectedProject()"
        >
        {{ constants.editProject }}
      </button>
    }

    <button
      type="submit"
      (click)="setAccessReview()"
      class="btn btn-primary me-2"
      [disabled]="!canEditSelectedProject()"
      >
      {{ constants.confirmAccessReview }}
    </button>

    <button
      type="button"
      (click)="confirmProjectDeletion()"
      class="btn btn-danger me-2"
      [disabled]="!canEditSelectedProject()"
      >
      {{ constants.deleteProject }}
    </button>
  </div>
}

<si-tabset-legacy [(selectedTabIndex)]="selectedTabIndex">
  <si-tab-legacy heading="{{ constants.project }}">
    <si-form-item
      label="{{ constants.projectName }}"
      [labelWidth]="labelWidthDummy"
      >
      <input
        type="text"
        id="dummyName"
        class="form-control"
        [ngModel]="selectedProject!.name"
        disabled
        />
      </si-form-item>

      <si-form-item
        label="{{ constants.projectId }}"
        [labelWidth]="labelWidthDummy"
        >
        <input
          type="text"
          id="dummyId"
          class="form-control"
          [ngModel]="selectedProject!.id"
          disabled
          />
        </si-form-item>

        <si-form-item
          label="{{ constants.parentProjectId }}"
          [labelWidth]="labelWidthDummy"
          >
          <input
            type="text"
            id="dummyParentId"
            class="form-control"
            [ngModel]="selectedProjectParentId"
            disabled
            />
          </si-form-item>

          <si-form-item
            label="{{ constants.description }}"
            [labelWidth]="labelWidthDummy"
            >
            <span>{{ selectedProject!.description }}</span>
          </si-form-item>

          <si-form-item
            label="{{ constants.lastAccessReview }}"
            [labelWidth]="labelWidthDummy"
            >
            <span>{{ sidePanelUserInfo.projectLastAccessReviewedAt }}</span>
          </si-form-item>

          <si-form-item
            label="{{ constants.lastAccessReviewBy }}"
            [labelWidth]="labelWidthDummy"
            >
            <span>{{ sidePanelUserInfo.projectLastAccessReviewedBy }}</span>
          </si-form-item>
        </si-tab-legacy>
        <si-tab-legacy heading="{{ constants.members }}" iconAltText="users">
          <div class="p-6">
            @if (isLoadingUsers) {
              <div class="d-flex justify-content-center p-5">
                <si-loading-spinner></si-loading-spinner>
              </div>
            } @else {
              <si-accordion class="add-user-accordion mb-4" [expandFirstPanel]="true">
                <si-collapsible-panel heading="Users">
                  <div class="p-4">
                    @if (!isReaderSelectedProject()) {
                        <div class="row g-3 align-items-end">
                          <div class="col-sm-6">
                            <input
                              type="email"
                              class="form-control"
                              id="emailInput"
                              placeholder="max.mustermann@siemens.com"
                              [(ngModel)]="emailOfUserToAdd"
                              autocomplete="off"
                            />
                            @if (isInvalidEmail) {
                              <div class="invalid_style">
                                {{ constants.invalidEmail }}
                              </div>
                            }
                          </div>
                          <div class="col-sm-3">
                            <label for="newUserRole" class="form-label">USS Role</label>
                            <select
                              id="newUserRole"
                              class="form-select"
                              [(ngModel)]="selectedRoleToAdd"
                              [disabled]="!canManageSelectedProjectUsers()"
                            >
                              @for (role of getAssignableRoles(); track role) {
                                <option [value]="role">{{ getRoleDisplayLabel(role) }}</option>
                              }
                            </select>
                          </div>
                          <div class="col-sm-3">
                            <button
                              type="button"
                              class="btn btn-primary w-100"
                              (click)="addUserToProject()"
                              [disabled]="!canManageSelectedProjectUsers()"
                            >
                              {{ constants.addUserToProject }}
                            </button>
                          </div>
                        </div>
                    }

                    <div class="position-relative mt-4">
                      <i
                        class="search-bar-icon icon element-search text-secondary ng-star-inserted"
                      ></i>
                      <input
                        type="text"
                        class="form-control ps-9 icon-start"
                        placeholder="Name or Email"
                        (keyup)="updateUserFilter($event)"
                        autocomplete="off"
                      />
                    </div>

                    <ngx-datatable
                      class="table-element elevation-1 mt-4"
                      [cssClasses]="tableConfig.cssClasses"
                      [rows]="sidePanelUserInfo?.userRows"
                      [rowHeight]="tableConfig.rowHeight"
                      [columnMode]="ColumnMode.force"
                      [headerHeight]="tableConfig.headerHeight"
                      [footerHeight]="0"
                      [ghostLoadingIndicator]="isLoadingUsers"
                      columnMode="force"
                      [selectionType]="selectionType"
                      siDatatableInteraction
                    >
                      <ngx-datatable-column name="Email" prop="email">
                      </ngx-datatable-column>
                      <ngx-datatable-column name="USS Role" prop="projectRole" [minWidth]="230">
                        <ng-template ngx-datatable-header-template>
                          <div class="uss-role-header">
                            <span>USS Role</span>
                            <button
                              type="button"
                              class="uss-role-info-trigger"
                              aria-label="Show USS and WIZ role information"
                              [siTooltip]="ussRolesInfoTooltipTpl"
                              placement="bottom"
                              (click)="$event.stopPropagation()"
                            >
                              I
                            </button>
                          </div>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                          @if (isReaderSelectedProject()) {
                            <span>{{ getRoleDisplayLabel(row.projectRole || 'Reader') }}</span>
                          } @else {
                            <select
                              class="form-select"
                              [(ngModel)]="selectedRoleByEmail[row.email]"
                              [disabled]="!canEditRoleForUser(row)"
                            >
                              @for (role of getRoleOptionsForUser(row); track role) {
                                <option [value]="role">{{ getRoleDisplayLabel(role) }}</option>
                              }
                            </select>
                          }
                        </ng-template>
                      </ngx-datatable-column>
                      <ng-template #ussRolesInfoTooltipTpl>
                        <div class="uss-role-info-popover">
                          <div class="uss-role-info-title">USS Roles</div>
                          <ul class="uss-role-info-list">
                            <li>
                              <strong>Owner</strong>: Manages subscriptions, clusters, and users
                            </li>
                            <li><strong>UserAdmin</strong>: Manages users</li>
                            <li><strong>Reader</strong>: Read-only access</li>
                          </ul>
                          <div class="uss-role-info-title">WIZ Roles</div>
                          <p class="uss-role-info-note">
                            All roles will become <strong>Siemens Project Admin</strong> in WIZ.
                          </p>
                        </div>
                      </ng-template>
                      @if (!isReaderSelectedProject()) {
                        <ngx-datatable-column name="Apply" [minWidth]="100" [canAutoResize]="false" [resizeable]="false">
                          <ng-template let-row="row" ngx-datatable-cell-template>
                            <button
                              type="button"
                              class="btn btn-secondary btn-sm"
                              (click)="updateUserRole(row)"
                              [disabled]="!canEditRoleForUser(row)"
                            >
                              Save
                            </button>
                          </ng-template>
                        </ngx-datatable-column>
                      }
                      @if (!isReaderSelectedProject()) {
                        <ngx-datatable-column
                          name="Remove"
                          prop="action"
                          [canAutoResize]="false"
                          [resizeable]="false"
                          [minWidth]="80"
                        >
                          <ng-template
                            let-value="value"
                            let-row="row"
                            ngx-datatable-cell-template
                          >
                            <button
                              class="btn btn-circle btn-lg btn-ghost element-delete me-6"
                              (click)="confirmRemoveUser(row.email)"
                              [disabled]="!canManageSelectedProjectUsers()"
                            ></button>
                          </ng-template>
                        </ngx-datatable-column>
                      }
                      <si-empty-state
                        empty-content
                        icon="element-users"
                        heading="{{ constants.noMembersAssigned }}"
                      ></si-empty-state>
                    </ngx-datatable>
                  </div>
                </si-collapsible-panel>
              </si-accordion>

              @if (!isReaderSelectedProject()) {
                <si-accordion class="entra-groups-accordion mt-4" [expandFirstPanel]="false">
                  <si-collapsible-panel heading="Entra ID Groups">
                    <div class="p-4">
                      <div class="row g-3 align-items-end mb-4">
                        <div class="col-sm-9">
                          <label for="entraGroupInput" class="form-label">{{ constants.addEntraGroup }}</label>
                          <input
                            type="text"
                            class="form-control"
                            id="entraGroupInput"
                            placeholder="{{ constants.entraGroupObjectId }}"
                            [(ngModel)]="entraGroupObjectIdToAdd"
                            [disabled]="!canManageSelectedProjectUsers()"
                            autocomplete="off"
                          />
                        </div>
                        <div class="col-sm-3">
                          <button
                            type="button"
                            class="btn btn-primary w-100"
                            (click)="addEntraGroupToProject()"
                            [disabled]="!canManageSelectedProjectUsers()"
                          >
                            {{ constants.addEntraGroupToProject }}
                          </button>
                        </div>
                      </div>

                      <div class="entra-group-list-box table-element elevation-1 p-4">
                        <label class="form-label d-block mb-3">{{ constants.assignEntraGroup }}</label>
                        @if (projectEntraGroups.length === 0) {
                          <div class="text-secondary">No Entra ID Groups assigned to the project</div>
                        } @else {
                          @for (group of projectEntraGroups; track group.groupObjectId) {
                            <div class="entra-group-row d-flex justify-content-between align-items-center py-2">
                              <div>
                                <div>{{ group.groupName || group.groupObjectId }}</div>
                                @if (group.groupName) {
                                  <div class="text-secondary small">{{ group.groupObjectId }}</div>
                                }
                              </div>
                              <button
                                type="button"
                                class="btn btn-secondary btn-sm"
                                (click)="removeEntraGroupMapping(group)"
                                [disabled]="!canManageSelectedProjectUsers()"
                              >
                                Remove
                              </button>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </si-collapsible-panel>
                </si-accordion>
              }
            }
            </div>
          </si-tab-legacy>
            @if (!selectedProject.isFolder) {
              <si-tab-legacy
                heading="{{ constants.subscriptions }}"
                >
                <div class="projectSubscriptionsTable p-5">
                  @if (isLoadingSubscriptions) {
                    <div class="d-flex justify-content-center p-5">
                      <si-loading-spinner></si-loading-spinner>
                    </div>
                  } @else {
                    <div class="mb-4 col-12">
                      <div class="position-relative">
                        <i
                          class="search-bar-icon icon element-search text-secondary ng-star-inserted"
                        ></i>
                        <input
                          type="text"
                          class="form-control ps-9 pe-24 icon-start"
                          placeholder="Name or Subscription ID"
                          [(ngModel)]="subscriptionSearchTerm"
                          (keyup.enter)="searchSubscriptions(subscriptionSearchTerm)"
                          autocomplete="off"
                          />
                        <div class="position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%); display: flex; gap: 8px; align-items: center;">
                          <i
                            class="icon element-search text-primary"
                            style="cursor: pointer; font-size: 22px;"
                            (click)="searchSubscriptions(subscriptionSearchTerm)"
                            title="Search"
                          ></i>
                          @if (subscriptionSearchTerm) {
                            <span
                              class="text-danger"
                              style="cursor: pointer; font-size: 22px; font-weight: bold; line-height: 1;"
                              (click)="clearSubscriptionSearch()"
                              title="Clear search"
                            >×</span>
                          }
                        </div>
                      </div>
                      <ngx-datatable
                        class="table-element elevation-1"
                        style="height: auto; min-height: 500px;"
                        [cssClasses]="tableConfig.cssClasses"
                        [rows]="sidePanelSubscriptionClusterInfo.projectSubscriptionRows"
                        [rowHeight]="tableConfig.rowHeight"
                        [columns]="projectSubsColumns"
                        [columnMode]="ColumnMode.force"
                        [headerHeight]="tableConfig.headerHeight"
                        [footerHeight]="0"
                        columnMode="force"
                        [limit]="10"
                        [offset]="0"
                        [count]="sidePanelSubscriptionClusterInfo.totalSubscriptions || 0"
                        [virtualization]="false"
                        [scrollbarV]="false"
                        siDatatableInteraction
                        >
                        <si-empty-state
                          empty-content
                          icon="element-users"
                          heading="{{ constants.noSubscriptionsAvailable }}"
                        ></si-empty-state>
                      </ngx-datatable>
                      <si-pagination
                        class="ms-auto mt-8"
                        [currentPage]="projectSubsPageNumber + 1"
                        [totalRowCount]="sidePanelSubscriptionClusterInfo.totalSubscriptions || 0"
                        [pageSize]="10"
                        forwardButtonText="forward"
                        backButtonText="back"
                        (currentPageChange)="onSubscriptionPageChange($event)"
                        >
                      </si-pagination>
                    </div>
                  }
                </div>
              </si-tab-legacy>
            }
            @if (!selectedProject.isFolder) {
              <si-tab-legacy
                heading="{{ constants.kubernetesCluster }}"
                  >
                  <div class="projectSubscriptionsTable p-5">
                    @if (isLoadingClusters) {
                      <div class="d-flex justify-content-center p-5">
                        <si-loading-spinner></si-loading-spinner>
                      </div>
                    } @else {
                      <div class="mb-4 col-12">
                        <div class="position-relative">
                          <i
                            class="search-bar-icon icon element-search text-secondary ng-star-inserted"
                          ></i>
                          <input
                            type="text"
                            class="form-control ps-9 pe-24 icon-start"
                            placeholder="Name or Cluster ID"
                            [(ngModel)]="clusterSearchTerm"
                            (keyup.enter)="searchClusters(clusterSearchTerm)"
                            autocomplete="off"
                            />
                          <div class="position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%); display: flex; gap: 8px; align-items: center;">
                            <i
                              class="icon element-search text-primary"
                              style="cursor: pointer; font-size: 22px;"
                              (click)="searchClusters(clusterSearchTerm)"
                              title="Search"
                            ></i>
                            @if (clusterSearchTerm) {
                              <span
                                class="text-danger"
                                style="cursor: pointer; font-size: 22px; font-weight: bold; line-height: 1;"
                                (click)="clearClusterSearch()"
                                title="Clear search"
                              >×</span>
                            }
                          </div>
                        </div>
                        <ngx-datatable
                          class="table-element elevation-1"
                          style="height: auto; min-height: 500px;"
                          [cssClasses]="tableConfig.cssClasses"
                          [rows]="sidePanelSubscriptionClusterInfo.clusterSubscriptionRows"
                          [rowHeight]="tableConfig.rowHeight"
                          [columns]="clusterSubsColumns"
                          [columnMode]="ColumnMode.force"
                          [headerHeight]="tableConfig.headerHeight"
                          [footerHeight]="0"
                          columnMode="force"
                          [limit]="10"
                          [offset]="0"
                          [count]="sidePanelSubscriptionClusterInfo.totalClusters || 0"
                          [virtualization]="false"
                          [scrollbarV]="false"
                          siDatatableInteraction
                          >
                          <si-empty-state
                            empty-content
                            icon="element-users"
                            heading="{{ constants.noClustersAvailable }}"
                          ></si-empty-state>
                        </ngx-datatable>
                        <si-pagination
                          class="ms-auto mt-8"
                          [currentPage]="clusterSubsPageNumber + 1"
                          [totalRowCount]="sidePanelSubscriptionClusterInfo.totalClusters || 0"
                          [pageSize]="10"
                          forwardButtonText="forward"
                          backButtonText="back"
                          (currentPageChange)="onClusterPageChange($event)"
                          >
                        </si-pagination>
                      </div>
                    }
                  </div>
                </si-tab-legacy>
              }
            </si-tabset-legacy>